import { render, staticRenderFns } from "./Collection.vue?vue&type=template&id=6da3a114&scoped=true"
import script from "./Collection.vue?vue&type=script&lang=js"
export * from "./Collection.vue?vue&type=script&lang=js"
import style0 from "./Collection.vue?vue&type=style&index=0&id=6da3a114&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6da3a114",
  null
  
)

export default component.exports